module.exports = __webpack_public_path__ + "static/media/settings-minus.93f6ecdb.svg";